import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Paths } from "../router/Paths";
import { NavType, setActiveNavTab } from "../reducer/uiReducer";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../app/store";
import { resetActiveTabs } from "../reducer/sideBarSlice";
import { resetTourState } from "../reducer/tourReducer";

interface NavItemProps {
  name: string;
  path?: string;
  image: string;
  tab: NavType;
  subNav?: { name: string; path: string }[];
}

const Navbar: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const pathToTab: { [key: string]: NavType } = {
      [Paths.welcome]: "home",
      [Paths.tourManagementCreate]: "create",
      [Paths.availablity]: "manage",
      [Paths.booking]: "booking",
      [Paths.finance]: "finance",
    };

    const currentTab = pathToTab[location.pathname];

    if (currentTab) {
      dispatch(setActiveNavTab(currentTab));
    }
  }, [location.pathname, dispatch]);

  return (
    <div className="w-full hidden lg:flex items-center justify-center shadow-md mt-20">
      <nav className={Classname.navContainer}>
        <NavItem
          image="/home.svg"
          name="Home"
          path={Paths.welcome}
          tab="home"
        />
        <NavItem
          image="/create.svg"
          name="Create"
          tab="create"
          subNav={[
            { name: "New Product", path: "/tourManagement/create" },
            { name: "Special Offer", path: "/create/special-offer" },
            { name: "Protocol Service", path: "/create/protocol" },
          ]}
        />
        <NavItem
          image="/manage.svg"
          name="Manage"
          tab="manage"
          subNav={[
            { name: "Availability", path: "/availablity" },
            { name: "Products", path: "/manage/product" },
            { name: "Special Offers", path: "/manage/special-offer" },
          ]}
        />
        <NavItem
          image="/booking.svg"
          name="Bookings"
          tab="booking"
          subNav={[
            { name: "Booking", path: "/booking" },
            // { name: "Ticket Scanner", path: "/ticket-scanner" },
          ]}
        />

        <NavItem
          image="/home.svg"
          name="Finance"
          path={Paths.finance}
          tab="finance"
        />
      </nav>
    </div>
  );
};

const NavItem: React.FC<NavItemProps> = ({
  name,
  path,
  image,
  tab,
  subNav,
}: NavItemProps) => {
  const { activeNavTab } = useSelector((state: RootState) => state.ui);
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();

  const isSubNavActive = subNav?.some(
    (item) => location.pathname === item.path
  );
  const isActive = activeNavTab === tab || isSubNavActive;

  const handleSubNavClick = (path: string) => {
    if (path === "/tourManagement/create") {
      console.log("Resetting active tabs and tour state...");
      dispatch(resetActiveTabs());
      dispatch(resetTourState());
      window.location.replace("/tourManagement/create");
    }
  };
  // useEffect(() => {
  //   if (location.pathname === "/tourManagement/create") {
  //     console.log("Resetting active tabs and tour state...");
  //     dispatch(resetTourState()); // Reset the tour state
  //     dispatch(resetActiveTabs()); // Reset active tabs if needed
  //   }
  // }, [location.pathname, dispatch]);

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        to={path || "#"}
        className={`flex-1 py-4 justify-center text-gray-500 text-center text-md font-medium lg:flex gap-2 items-center ${
          isActive ? "border-b-4 border-blue-500" : ""
        }`}
      >
        <div className="justify-center flex">
          <img src={image} alt={name} />
        </div>
        <div>{name}</div>
        {subNav && (
          <span
            className={`ml-2 transition-transform ${
              isHovered ? "rotate-180" : ""
            }`}
          >
            <img src="/down-arrow-icon.png" className="w-5" />
          </span>
        )}
      </Link>

      {isHovered && subNav && (
        <div className="absolute top-full left-0 bg-white shadow-md shadow-gray-400">
          {subNav.map((item, index) => {
            const isCurrentSubNavActive = location.pathname === item.path;
            return (
              <Link
                key={index}
                to={item.path}
                onClick={() => handleSubNavClick(item.path)}
                className={`flex flex-col py-3 text-md font-bold w-72 px-3 mr-30 ${
                  isCurrentSubNavActive
                    ? "border-b-2 border-blue-500"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
                style={{
                  display: "inline-block",
                }}
              >
                {item.name}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Navbar;

const Classname = {
  navContainer:
    "flex bg-white items-center justify-between px-2 w-full max-w-7xl",
};
